/*
 * # Fomantic UI - 2.8.8
 * https://github.com/fomantic/Fomantic-UI
 * http://fomantic-ui.com/
 *
 * Copyright 2021 Contributors
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
!function (q, k, D, E) {
  "use strict";

  q.isFunction = q.isFunction || function (e) {
    return "function" == typeof e && "number" != typeof e.nodeType;
  }, k = void 0 !== k && k.Math == Math ? k : "undefined" != typeof self && self.Math == Math ? self : Function("return this")(), q.fn.search = function (u) {
    var x,
      C = q(this),
      w = C.selector || "",
      S = new Date().getTime(),
      T = [],
      F = u,
      j = "string" == typeof F,
      A = [].slice.call(arguments, 1);
    return q(this).each(function () {
      var f,
        l = q.isPlainObject(u) ? q.extend(!0, {}, q.fn.search.settings, u) : q.extend({}, q.fn.search.settings),
        g = l.className,
        d = l.metadata,
        n = l.regExp,
        i = l.fields,
        h = l.selector,
        p = l.error,
        e = l.namespace,
        r = "." + e,
        t = e + "-module",
        m = q(this),
        v = m.find(h.prompt),
        s = m.find(h.searchButton),
        a = m.find(h.results),
        o = m.find(h.result),
        y = (m.find(h.category), this),
        c = m.data(t),
        b = !1,
        R = !1;
      f = {
        initialize: function () {
          f.verbose("Initializing module"), f.get.settings(), f.determine.searchFields(), f.bind.events(), f.set.type(), f.create.results(), f.instantiate();
        },
        instantiate: function () {
          f.verbose("Storing instance of module", f), c = f, m.data(t, f);
        },
        destroy: function () {
          f.verbose("Destroying instance"), m.off(r).removeData(t);
        },
        refresh: function () {
          f.debug("Refreshing selector cache"), v = m.find(h.prompt), s = m.find(h.searchButton), m.find(h.category), a = m.find(h.results), o = m.find(h.result);
        },
        refreshResults: function () {
          a = m.find(h.results), o = m.find(h.result);
        },
        bind: {
          events: function () {
            f.verbose("Binding events to search"), l.automatic && (m.on(f.get.inputEvent() + r, h.prompt, f.event.input), v.attr("autocomplete", f.is.chrome() ? "fomantic-search" : "off")), m.on("focus" + r, h.prompt, f.event.focus).on("blur" + r, h.prompt, f.event.blur).on("keydown" + r, h.prompt, f.handleKeyboard).on("click" + r, h.searchButton, f.query).on("mousedown" + r, h.results, f.event.result.mousedown).on("mouseup" + r, h.results, f.event.result.mouseup).on("click" + r, h.result, f.event.result.click);
          }
        },
        determine: {
          searchFields: function () {
            u && u.searchFields !== E && (l.searchFields = u.searchFields);
          }
        },
        event: {
          input: function () {
            l.searchDelay ? (clearTimeout(f.timer), f.timer = setTimeout(function () {
              f.is.focused() && f.query();
            }, l.searchDelay)) : f.query();
          },
          focus: function () {
            f.set.focus(), l.searchOnFocus && f.has.minimumCharacters() && f.query(function () {
              f.can.show() && f.showResults();
            });
          },
          blur: function (e) {
            function t() {
              f.cancel.query(), f.remove.focus(), f.timer = setTimeout(f.hideResults, l.hideDelay);
            }
            var s = D.activeElement === this;
            s || (R = !1, f.resultsClicked ? (f.debug("Determining if user action caused search to close"), m.one("click.close" + r, h.results, function (e) {
              f.is.inMessage(e) || b ? v.focus() : (b = !1, f.is.animating() || f.is.hidden() || t());
            })) : (f.debug("Input blurred without user action, closing results"), t()));
          },
          result: {
            mousedown: function () {
              f.resultsClicked = !0;
            },
            mouseup: function () {
              f.resultsClicked = !1;
            },
            click: function (e) {
              f.debug("Search result selected");
              var t = q(this),
                s = t.find(h.title).eq(0),
                n = t.is("a[href]") ? t : t.find("a[href]").eq(0),
                r = n.attr("href") || !1,
                i = n.attr("target") || !1,
                a = 0 < s.length && s.text(),
                o = f.get.results(),
                c = t.data(d.result) || f.get.result(a, o),
                u = f.get.value();
              if (q.isFunction(l.onSelect) && !1 === l.onSelect.call(y, c, o)) return f.debug("Custom onSelect callback cancelled default select action"), void (b = !0);
              f.hideResults(), a && f.get.value() === u && f.set.value(a), r && (e.preventDefault(), f.verbose("Opening search link found in result", n), "_blank" == i || e.ctrlKey ? k.open(r) : k.location.href = r);
            }
          }
        },
        ensureVisible: function (e) {
          var t, s, n, r;
          0 !== e.length && (s = (t = e.position().top) + e.outerHeight(!0), n = a.scrollTop(), r = a.height(), t < 0 ? a.scrollTop(n + t) : r < s && a.scrollTop(n + (s - r)));
        },
        handleKeyboard: function (e) {
          var t,
            s = m.find(h.result),
            n = m.find(h.category),
            r = s.filter("." + g.active),
            i = s.index(r),
            a = s.length,
            o = 0 < r.length,
            c = e.which,
            u = 13,
            l = 38,
            d = 40;
          if (c == 27 && (f.verbose("Escape key pressed, blurring search field"), f.hideResults(), R = !0), f.is.visible()) {
            if (c == u) {
              if (f.verbose("Enter key pressed, selecting active result"), 0 < s.filter("." + g.active).length) return f.event.result.click.call(s.filter("." + g.active), e), e.preventDefault(), !1;
            } else c == l && o ? (f.verbose("Up key pressed, changing active result"), t = i - 1 < 0 ? i : i - 1, n.removeClass(g.active), s.removeClass(g.active).eq(t).addClass(g.active).closest(n).addClass(g.active), f.ensureVisible(s.eq(t)), e.preventDefault()) : c == d && (f.verbose("Down key pressed, changing active result"), t = a <= i + 1 ? i : i + 1, n.removeClass(g.active), s.removeClass(g.active).eq(t).addClass(g.active).closest(n).addClass(g.active), f.ensureVisible(s.eq(t)), e.preventDefault());
          } else c == u && (f.verbose("Enter key pressed, executing query"), f.query(), f.set.buttonPressed(), v.one("keyup", f.remove.buttonFocus));
        },
        setup: {
          api: function (t, s) {
            var e = {
              debug: l.debug,
              on: !1,
              cache: l.cache,
              action: "search",
              urlData: {
                query: t
              },
              onSuccess: function (e) {
                f.parse.response.call(y, e, t), s();
              },
              onFailure: function () {
                f.displayMessage(p.serverError), s();
              },
              onAbort: function (e) {},
              onError: f.error
            };
            q.extend(!0, e, l.apiSettings), f.verbose("Setting up API request", e), m.api(e);
          }
        },
        can: {
          useAPI: function () {
            return q.fn.api !== E;
          },
          show: function () {
            return f.is.focused() && !f.is.visible() && !f.is.empty();
          },
          transition: function () {
            return l.transition && q.fn.transition !== E && m.transition("is supported");
          }
        },
        is: {
          animating: function () {
            return a.hasClass(g.animating);
          },
          chrome: function () {
            return !(!k.chrome || !k.chrome.webstore && !k.chrome.runtime);
          },
          hidden: function () {
            return a.hasClass(g.hidden);
          },
          inMessage: function (e) {
            if (e.target) {
              var t = q(e.target);
              return q.contains(D.documentElement, e.target) && 0 < t.closest(h.message).length;
            }
          },
          empty: function () {
            return "" === a.html();
          },
          visible: function () {
            return 0 < a.filter(":visible").length;
          },
          focused: function () {
            return 0 < v.filter(":focus").length;
          }
        },
        get: {
          settings: function () {
            q.isPlainObject(u) && u.searchFullText && (l.fullTextSearch = u.searchFullText, f.error(l.error.oldSearchSyntax, y)), l.ignoreDiacritics && !String.prototype.normalize && (l.ignoreDiacritics = !1, f.error(p.noNormalize, y));
          },
          inputEvent: function () {
            var e = v[0];
            return e !== E && e.oninput !== E ? "input" : e !== E && e.onpropertychange !== E ? "propertychange" : "keyup";
          },
          value: function () {
            return v.val();
          },
          results: function () {
            return m.data(d.results);
          },
          result: function (s, e) {
            var n = !1;
            return s = s !== E ? s : f.get.value(), e = e !== E ? e : f.get.results(), "category" === l.type ? (f.debug("Finding result that matches", s), q.each(e, function (e, t) {
              if (Array.isArray(t.results) && (n = f.search.object(s, t.results)[0])) return !1;
            })) : (f.debug("Finding result in results object", s), n = f.search.object(s, e)[0]), n || !1;
          }
        },
        select: {
          firstResult: function () {
            f.verbose("Selecting first result"), o.first().addClass(g.active);
          }
        },
        set: {
          focus: function () {
            m.addClass(g.focus);
          },
          loading: function () {
            m.addClass(g.loading);
          },
          value: function (e) {
            f.verbose("Setting search input value", e), v.val(e);
          },
          type: function (e) {
            e = e || l.type, "category" == l.type && m.addClass(l.type);
          },
          buttonPressed: function () {
            s.addClass(g.pressed);
          }
        },
        remove: {
          loading: function () {
            m.removeClass(g.loading);
          },
          focus: function () {
            m.removeClass(g.focus);
          },
          buttonPressed: function () {
            s.removeClass(g.pressed);
          },
          diacritics: function (e) {
            return l.ignoreDiacritics ? e.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : e;
          }
        },
        query: function (e) {
          e = q.isFunction(e) ? e : function () {};
          var t = f.get.value(),
            s = f.read.cache(t);
          e = e || function () {}, f.has.minimumCharacters() ? (s ? (f.debug("Reading result from cache", t), f.save.results(s.results), f.addResults(s.html), f.inject.id(s.results), e()) : (f.debug("Querying for", t), q.isPlainObject(l.source) || Array.isArray(l.source) ? (f.search.local(t), e()) : f.can.useAPI() ? f.search.remote(t, e) : (f.error(p.source), e())), l.onSearchQuery.call(y, t)) : f.hideResults();
        },
        search: {
          local: function (e) {
            var t,
              s = f.search.object(e, l.source);
            f.set.loading(), f.save.results(s), f.debug("Returned full local search results", s), 0 < l.maxResults && (f.debug("Using specified max results", s), s = s.slice(0, l.maxResults)), "category" == l.type && (s = f.create.categoryResults(s)), t = f.generateResults({
              results: s
            }), f.remove.loading(), f.addResults(t), f.inject.id(s), f.write.cache(e, {
              html: t,
              results: s
            });
          },
          remote: function (e, t) {
            t = q.isFunction(t) ? t : function () {}, m.api("is loading") && m.api("abort"), f.setup.api(e, t), m.api("query");
          },
          object: function (r, t, e) {
            r = f.remove.diacritics(String(r));
            function i(e, t) {
              var s = -1 == q.inArray(t, a),
                n = -1 == q.inArray(t, c),
                r = -1 == q.inArray(t, o);
              s && n && r && e.push(t);
            }
            var a = [],
              o = [],
              c = [],
              s = r.replace(n.escape, "\\$&"),
              u = new RegExp(n.beginsWith + s, "i");
            return t = t || l.source, e = e !== E ? e : l.searchFields, Array.isArray(e) || (e = [e]), t === E || !1 === t ? (f.error(p.source), []) : (q.each(e, function (e, n) {
              q.each(t, function (e, t) {
                var s;
                "string" != typeof t[n] && "number" != typeof t[n] || (-1 !== (s = "string" == typeof t[n] ? f.remove.diacritics(t[n]) : t[n].toString()).search(u) ? i(a, t) : "exact" === l.fullTextSearch && f.exactSearch(r, s) ? i(o, t) : 1 == l.fullTextSearch && f.fuzzySearch(r, s) && i(c, t));
              });
            }), q.merge(o, c), q.merge(a, o), a);
          }
        },
        exactSearch: function (e, t) {
          return e = e.toLowerCase(), -1 < (t = t.toLowerCase()).indexOf(e);
        },
        fuzzySearch: function (e, t) {
          var s = t.length,
            n = e.length;
          if ("string" != typeof e) return !1;
          if (e = e.toLowerCase(), t = t.toLowerCase(), s < n) return !1;
          if (n === s) return e === t;
          e: for (var r = 0, i = 0; r < n; r++) {
            for (var a = e.charCodeAt(r); i < s;) if (t.charCodeAt(i++) === a) continue e;
            return !1;
          }
          return !0;
        },
        parse: {
          response: function (e, t) {
            if (Array.isArray(e)) {
              var s = {};
              s[i.results] = e, e = s;
            }
            var n = f.generateResults(e);
            f.verbose("Parsing server response", e), e !== E && t !== E && e[i.results] !== E && (f.addResults(n), f.inject.id(e[i.results]), f.write.cache(t, {
              html: n,
              results: e[i.results]
            }), f.save.results(e[i.results]));
          }
        },
        cancel: {
          query: function () {
            f.can.useAPI() && m.api("abort");
          }
        },
        has: {
          minimumCharacters: function () {
            return f.get.value().length >= l.minCharacters;
          },
          results: function () {
            return 0 !== a.length && "" != a.html();
          }
        },
        clear: {
          cache: function (e) {
            var t = m.data(d.cache);
            e ? e && t && t[e] && (f.debug("Removing value from cache", e), delete t[e], m.data(d.cache, t)) : (f.debug("Clearing cache", e), m.removeData(d.cache));
          }
        },
        read: {
          cache: function (e) {
            var t = m.data(d.cache);
            return !!l.cache && (f.verbose("Checking cache for generated html for query", e), "object" == typeof t && t[e] !== E && t[e]);
          }
        },
        create: {
          categoryResults: function (e) {
            var s = {};
            return q.each(e, function (e, t) {
              t.category && (s[t.category] === E ? (f.verbose("Creating new category of results", t.category), s[t.category] = {
                name: t.category,
                results: [t]
              }) : s[t.category].results.push(t));
            }), s;
          },
          id: function (e, t) {
            var s,
              n = e + 1;
            return t !== E ? (s = String.fromCharCode(97 + t) + n, f.verbose("Creating category result id", s)) : (s = n, f.verbose("Creating result id", s)), s;
          },
          results: function () {
            0 === a.length && (a = q("<div />").addClass(g.results).appendTo(m));
          }
        },
        inject: {
          result: function (e, t, s) {
            f.verbose("Injecting result into results");
            var n = s !== E ? a.children().eq(s).children(h.results).first().children(h.result).eq(t) : a.children(h.result).eq(t);
            f.verbose("Injecting results metadata", n), n.data(d.result, e);
          },
          id: function (e) {
            f.debug("Injecting unique ids into results");
            var s = 0,
              n = 0;
            return "category" === l.type ? q.each(e, function (e, t) {
              0 < t.results.length && (n = 0, q.each(t.results, function (e, t) {
                t.id === E && (t.id = f.create.id(n, s)), f.inject.result(t, n, s), n++;
              }), s++);
            }) : q.each(e, function (e, t) {
              t.id === E && (t.id = f.create.id(n)), f.inject.result(t, n), n++;
            }), e;
          }
        },
        save: {
          results: function (e) {
            f.verbose("Saving current search results to metadata", e), m.data(d.results, e);
          }
        },
        write: {
          cache: function (e, t) {
            var s = m.data(d.cache) !== E ? m.data(d.cache) : {};
            l.cache && (f.verbose("Writing generated html to cache", e, t), s[e] = t, m.data(d.cache, s));
          }
        },
        addResults: function (e) {
          if (q.isFunction(l.onResultsAdd) && !1 === l.onResultsAdd.call(a, e)) return f.debug("onResultsAdd callback cancelled default action"), !1;
          e ? (a.html(e), f.refreshResults(), l.selectFirstResult && f.select.firstResult(), f.showResults()) : f.hideResults(function () {
            a.empty();
          });
        },
        showResults: function (e) {
          e = q.isFunction(e) ? e : function () {}, R || !f.is.visible() && f.has.results() && (f.can.transition() ? (f.debug("Showing results with css animations"), a.transition({
            animation: l.transition + " in",
            debug: l.debug,
            verbose: l.verbose,
            duration: l.duration,
            onShow: function () {
              var e = m.find(h.result).eq(0);
              f.ensureVisible(e);
            },
            onComplete: function () {
              e();
            },
            queue: !0
          })) : (f.debug("Showing results with javascript"), a.stop().fadeIn(l.duration, l.easing)), l.onResultsOpen.call(a));
        },
        hideResults: function (e) {
          e = q.isFunction(e) ? e : function () {}, f.is.visible() && (f.can.transition() ? (f.debug("Hiding results with css animations"), a.transition({
            animation: l.transition + " out",
            debug: l.debug,
            verbose: l.verbose,
            duration: l.duration,
            onComplete: function () {
              e();
            },
            queue: !0
          })) : (f.debug("Hiding results with javascript"), a.stop().fadeOut(l.duration, l.easing)), l.onResultsClose.call(a));
        },
        generateResults: function (e) {
          f.debug("Generating html from response", e);
          var t = l.templates[l.type],
            s = q.isPlainObject(e[i.results]) && !q.isEmptyObject(e[i.results]),
            n = Array.isArray(e[i.results]) && 0 < e[i.results].length,
            r = "";
          return s || n ? (0 < l.maxResults && (s ? "standard" == l.type && f.error(p.maxResults) : e[i.results] = e[i.results].slice(0, l.maxResults)), q.isFunction(t) ? r = t(e, i, l.preserveHTML) : f.error(p.noTemplate, !1)) : l.showNoResults && (r = f.displayMessage(p.noResults, "empty", p.noResultsHeader)), l.onResults.call(y, e), r;
        },
        displayMessage: function (e, t, s) {
          return t = t || "standard", f.debug("Displaying message", e, t, s), f.addResults(l.templates.message(e, t, s)), l.templates.message(e, t, s);
        },
        setting: function (e, t) {
          if (q.isPlainObject(e)) q.extend(!0, l, e);else {
            if (t === E) return l[e];
            l[e] = t;
          }
        },
        internal: function (e, t) {
          if (q.isPlainObject(e)) q.extend(!0, f, e);else {
            if (t === E) return f[e];
            f[e] = t;
          }
        },
        debug: function () {
          !l.silent && l.debug && (l.performance ? f.performance.log(arguments) : (f.debug = Function.prototype.bind.call(console.info, console, l.name + ":"), f.debug.apply(console, arguments)));
        },
        verbose: function () {
          !l.silent && l.verbose && l.debug && (l.performance ? f.performance.log(arguments) : (f.verbose = Function.prototype.bind.call(console.info, console, l.name + ":"), f.verbose.apply(console, arguments)));
        },
        error: function () {
          l.silent || (f.error = Function.prototype.bind.call(console.error, console, l.name + ":"), f.error.apply(console, arguments));
        },
        performance: {
          log: function (e) {
            var t, s;
            l.performance && (s = (t = new Date().getTime()) - (S || t), S = t, T.push({
              Name: e[0],
              Arguments: [].slice.call(e, 1) || "",
              Element: y,
              "Execution Time": s
            })), clearTimeout(f.performance.timer), f.performance.timer = setTimeout(f.performance.display, 500);
          },
          display: function () {
            var e = l.name + ":",
              s = 0;
            S = !1, clearTimeout(f.performance.timer), q.each(T, function (e, t) {
              s += t["Execution Time"];
            }), e += " " + s + "ms", w && (e += " '" + w + "'"), 1 < C.length && (e += " (" + C.length + ")"), (console.group !== E || console.table !== E) && 0 < T.length && (console.groupCollapsed(e), console.table ? console.table(T) : q.each(T, function (e, t) {
              console.log(t.Name + ": " + t["Execution Time"] + "ms");
            }), console.groupEnd()), T = [];
          }
        },
        invoke: function (n, e, t) {
          var r,
            i,
            s,
            a = c;
          return e = e || A, t = y || t, "string" == typeof n && a !== E && (n = n.split(/[\. ]/), r = n.length - 1, q.each(n, function (e, t) {
            var s = e != r ? t + n[e + 1].charAt(0).toUpperCase() + n[e + 1].slice(1) : n;
            if (q.isPlainObject(a[s]) && e != r) a = a[s];else {
              if (a[s] !== E) return i = a[s], !1;
              if (!q.isPlainObject(a[t]) || e == r) return a[t] !== E && (i = a[t]), !1;
              a = a[t];
            }
          })), q.isFunction(i) ? s = i.apply(t, e) : i !== E && (s = i), Array.isArray(x) ? x.push(s) : x !== E ? x = [x, s] : s !== E && (x = s), i;
        }
      }, j ? (c === E && f.initialize(), f.invoke(F)) : (c !== E && c.invoke("destroy"), f.initialize());
    }), x !== E ? x : this;
  }, q.fn.search.settings = {
    name: "Search",
    namespace: "search",
    silent: !1,
    debug: !1,
    verbose: !1,
    performance: !0,
    type: "standard",
    minCharacters: 1,
    selectFirstResult: !1,
    apiSettings: !1,
    source: !1,
    searchOnFocus: !0,
    searchFields: ["id", "title", "description"],
    displayField: "",
    fullTextSearch: "exact",
    ignoreDiacritics: !1,
    automatic: !0,
    hideDelay: 0,
    searchDelay: 200,
    maxResults: 7,
    cache: !0,
    showNoResults: !0,
    preserveHTML: !0,
    transition: "scale",
    duration: 200,
    easing: "easeOutExpo",
    onSelect: !1,
    onResultsAdd: !1,
    onSearchQuery: function (e) {},
    onResults: function (e) {},
    onResultsOpen: function () {},
    onResultsClose: function () {},
    className: {
      animating: "animating",
      active: "active",
      empty: "empty",
      focus: "focus",
      hidden: "hidden",
      loading: "loading",
      results: "results",
      pressed: "down"
    },
    error: {
      source: "Cannot search. No source used, and Semantic API module was not included",
      noResultsHeader: "No Results",
      noResults: "Your search returned no results",
      logging: "Error in debug logging, exiting.",
      noEndpoint: "No search endpoint was specified",
      noTemplate: "A valid template name was not specified.",
      oldSearchSyntax: "searchFullText setting has been renamed fullTextSearch for consistency, please adjust your settings.",
      serverError: "There was an issue querying the server.",
      maxResults: "Results must be an array to use maxResults setting",
      method: "The method you called is not defined.",
      noNormalize: '"ignoreDiacritics" setting will be ignored. Browser does not support String().normalize(). You may consider including <https://cdn.jsdelivr.net/npm/unorm@1.4.1/lib/unorm.min.js> as a polyfill.'
    },
    metadata: {
      cache: "cache",
      results: "results",
      result: "result"
    },
    regExp: {
      escape: /[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g,
      beginsWith: "(?:s|^)"
    },
    fields: {
      categories: "results",
      categoryName: "name",
      categoryResults: "results",
      description: "description",
      image: "image",
      price: "price",
      results: "results",
      title: "title",
      url: "url",
      action: "action",
      actionText: "text",
      actionURL: "url"
    },
    selector: {
      prompt: ".prompt",
      searchButton: ".search.button",
      results: ".results",
      message: ".results > .message",
      category: ".category",
      result: ".result",
      title: ".title, .name"
    },
    templates: {
      escape: function (e, t) {
        if (t) return e;
        var s = {
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#x27;",
          "`": "&#x60;"
        };
        return /[&<>"'`]/.test(e) ? (e = e.replace(/&(?![a-z0-9#]{1,6};)/, "&amp;")).replace(/[<>"'`]/g, function (e) {
          return s[e];
        }) : e;
      },
      message: function (e, t, s) {
        var n = "";
        return e !== E && t !== E && (n += '<div class="message ' + t + '">', s && (n += '<div class="header">' + s + "</div>"), n += ' <div class="description">' + e + "</div>", n += "</div>"), n;
      },
      category: function (e, s, n) {
        var r = "",
          i = q.fn.search.settings.templates.escape;
        return e[s.categoryResults] !== E && (q.each(e[s.categoryResults], function (e, t) {
          t[s.results] !== E && 0 < t.results.length && (r += '<div class="category">', t[s.categoryName] !== E && (r += '<div class="name">' + i(t[s.categoryName], n) + "</div>"), r += '<div class="results">', q.each(t.results, function (e, t) {
            t[s.url] ? r += '<a class="result" href="' + t[s.url].replace(/"/g, "") + '">' : r += '<a class="result">', t[s.image] !== E && (r += '<div class="image"> <img src="' + t[s.image].replace(/"/g, "") + '"></div>'), r += '<div class="content">', t[s.price] !== E && (r += '<div class="price">' + i(t[s.price], n) + "</div>"), t[s.title] !== E && (r += '<div class="title">' + i(t[s.title], n) + "</div>"), t[s.description] !== E && (r += '<div class="description">' + i(t[s.description], n) + "</div>"), r += "</div>", r += "</a>";
          }), r += "</div>", r += "</div>");
        }), e[s.action] && (!1 === s.actionURL ? r += '<div class="action">' + i(e[s.action][s.actionText], n) + "</div>" : r += '<a href="' + e[s.action][s.actionURL].replace(/"/g, "") + '" class="action">' + i(e[s.action][s.actionText], n) + "</a>"), r);
      },
      standard: function (e, s, n) {
        var r = "",
          i = q.fn.search.settings.templates.escape;
        return e[s.results] !== E && (q.each(e[s.results], function (e, t) {
          t[s.url] ? r += '<a class="result" href="' + t[s.url].replace(/"/g, "") + '">' : r += '<a class="result">', t[s.image] !== E && (r += '<div class="image"> <img src="' + t[s.image].replace(/"/g, "") + '"></div>'), r += '<div class="content">', t[s.price] !== E && (r += '<div class="price">' + i(t[s.price], n) + "</div>"), t[s.title] !== E && (r += '<div class="title">' + i(t[s.title], n) + "</div>"), t[s.description] !== E && (r += '<div class="description">' + i(t[s.description], n) + "</div>"), r += "</div>", r += "</a>";
        }), e[s.action] && (!1 === s.actionURL ? r += '<div class="action">' + i(e[s.action][s.actionText], n) + "</div>" : r += '<a href="' + e[s.action][s.actionURL].replace(/"/g, "") + '" class="action">' + i(e[s.action][s.actionText], n) + "</a>"), r);
      }
    }
  };
}(jQuery, window, document);